import { render } from "./LoadingIcon.vue?vue&type=template&id=12c99f74&scoped=true&ts=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"

import "./LoadingIcon.vue?vue&type=style&index=0&id=12c99f74&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c99f74"]])

export default __exports__